import { Order } from 'shared/types/cart';
import { sdk } from 'sdk';

export const fetchOrder = async (orderNumber: string) => {
  try {
    const response = await sdk.callAction<{ order: Order }>({
      actionName: 'order/getOrderByOrderNumber',
      payload: { orderNumber },
    });

    if (response.isError || !response?.data?.order) {
      return {
        data: null,
      };
    }

    const order = response?.data?.order;

    return {
      data: order,
    };
  } catch {
    return {
      data: null,
    };
  }
};
